module.exports = __webpack_public_path__ + "img/express.1c052762.jpg";